<template>
  <el-tooltip content="Created from client portal" placement="bottom" v-if="initial_record.is_cp">
    <el-tag class="client-portal-badge-tag status-pill">
      CP
    </el-tag>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    initial_record: {
      type: Object,
      required: true
    },
  },
}
</script>
<style scoped>
.client-portal-badge-tag {
  color: #649496 !important;
  background: #cadadb !important;
  border-color: #649496 !important;
  font-weight: bold;
}
</style>
